import styled from 'styled-components';
import {dFlexColumn, dFlexStart} from '../../../../globalVariables/GlobalFlex';
import {BLACK, DEFAULT_COLOR, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const summaryStats = styled.div`
    ${dFlexStart}
    gap: 6px;
    padding: 14px 0;
    flex-wrap: wrap;
`;

export const summaryStatItem = styled.div`
    gap: 4px;
    font-size: 14px;
    color: ${BLACK};
    min-width: fit-content;
    max-width: 200px;
    font-weight: 700;
    text-align: center;
    word-wrap: break-word;
    position: relative;
    margin-inline-end: 12px;
    
    ${mobileMedia}{
        font-size: 12px;
    }
    &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: calc(50% - 3px);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-inline-start: 6px;
        background: ${DEFAULT_COLOR};
    }
    
    ${mobileMedia} {
        font-size: 12px;
        max-width: 150px;
    }
`;
